import { AxiosResponse } from "axios";
import { camelizeObject, snakizeObject } from "shared/helpers/object";
import { ApiBaseUrl, request } from "shared/clients/baseClient";
import { PaginatedResults } from "types/Query";
import { SupportingInfo } from "../supportingInfo";

const getRelatedSupportingInfos = (
  surveyId: number | string,
  blockId: number | string
): Promise<AxiosResponse<PaginatedResults<SupportingInfo.RelatedSupportingInfo>>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${surveyId}/survey_block/${blockId}/related_supporting_information/`,
      method: "GET",
    },
  }).then((data: AxiosResponse<PaginatedResults<SupportingInfo.RelatedSupportingInfoApi>>) => {
    return {
      ...data,
      data: {
        ...data.data,
        results: data.data.results.map(camelizeObject<SupportingInfo.RelatedSupportingInfo>),
      },
    };
  });
};

const addSupportingInfoToBlock = (
  surveyId: number | string,
  blockId: number | string,
  infoId: number | string,
  tabName?: string | null,
): Promise<AxiosResponse<SupportingInfo.RelatedSupportingInfo>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${surveyId}/survey_block/${blockId}/related_supporting_information/`,
      method: "POST",
      data: snakizeObject({ supportingInformation: infoId, tabName }),
    },
  }).then((data: AxiosResponse<SupportingInfo.RelatedSupportingInfoApi>) => camelizeObject(data));
};

const updateRelatedSupportingInfo = (
  surveyId: number | string,
  blockId: number | string,
  relatedInfoId: number | string,
  params: SupportingInfo.PartialRelatedSupportingInfoForUpdate
) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${surveyId}/survey_block/${blockId}/related_supporting_information/${relatedInfoId}/`,
      method: "PATCH",
      data: snakizeObject(params),
    },
  });
};

const deleteSupportingInfoFromBlock = (
  surveyId: number | string,
  blockId: number | string,
  infoId: number | string
) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${surveyId}/survey_block/${blockId}/related_supporting_information/${infoId}/`,
      method: "DELETE",
    },
  });
};

export const relatedSupportingInfoClient = {
  getRelatedSupportingInfos,
  addSupportingInfoToBlock,
  updateRelatedSupportingInfo,
  deleteSupportingInfoFromBlock,
};
